import { TrackingMethod } from "@/interfaces";

function findSCORM12API(win: Window) {
  let findAPITries = 0;
  // Check to see if the window (win) contains the API
  // if the window (win) does not contain the API and
  // the window (win) has a parent window and the parent window
  // is not the same as the window (win)
  while (win.API == null && win.parent != null && win.parent != win) {
    // increment the number of findAPITries
    findAPITries++;

    // Note: 7 is an arbitrary number, but should be more than sufficient
    if (findAPITries > 7) {
      console.error("Error finding API -- too deeply nested.");
      return null;
    }

    // set the variable that represents the window being
    // being searched to be the parent of the current window
    // then search for the API again
    win = win.parent;
  }
  return win.API;
}

function getSCORM12API() {
  // start by looking for the API in the current window
  let theAPI = findSCORM12API(window);

  // if the API is null (could not be found in the current window)
  // and the current window has an opener window
  if (
    theAPI == null &&
    window.opener != null &&
    typeof window.opener != "undefined"
  ) {
    // try to find the API in the current window’s opener
    theAPI = findSCORM12API(window.opener);
  }
  // if the API has not been found
  if (theAPI == null) {
    // Alert the user that the API Adapter could not be found
    console.error("Unable to find an API adapter");
  }
  return theAPI;
}

// The ScanForAPI() function searches for an object named API_1484_11
// in the window that is passed into the function. If the object is
// found a reference to the object is returned to the calling function.
// If the instance is found the SCO now has a handle to the LMS
// provided API Instance. The function searches a maximum number
// of parents of the current window. If no object is found the
// function returns a null reference. This function also reassigns a
// value to the win parameter passed in, based on the number of
// parents. At the end of the function call, the win variable will be
// set to the upper most parent in the chain of parents.
function ScanForSCORM2004API(win: Window) {
  let nFindAPITries = 0;
  const maxTries = 500;
  while (win.API_1484_11 == null && win.parent != null && win.parent != win) {
    nFindAPITries++;
    if (nFindAPITries > maxTries) {
      return null;
    }
    win = win.parent;
  }
  return win.API_1484_11;
}

// The GetAPI() function begins the process of searching for the LMS
// provided API Instance. The function takes in a parameter that
// represents the current window. The function is built to search in a
// specific order and stop when the LMS provided API Instance is found.
// The function begins by searching the current window’s parent, if the
// current window has a parent. If the API Instance is not found, the
// function then checks to see if there are any opener windows. If
// the window has an opener, the function begins to look for the
// API Instance in the opener window.
function getSCORM2004API() {
  let API_1484_11 = null;
  if (window.parent != null && window.parent != window) {
    API_1484_11 = ScanForSCORM2004API(window.parent);
  }
  if (API_1484_11 == null && window.opener != null) {
    API_1484_11 = ScanForSCORM2004API(window.opener);
  }
}

export default (trackingMethod: TrackingMethod): void => {
  console.log("Resetting", trackingMethod, "Tracking");
  const API = getSCORM12API();
  const API_1484_11 = getSCORM2004API();
  if (trackingMethod === "SCORM 1.2" && API) {
    console.log("Found", trackingMethod, "API");
    API.LMSInitialize("");
    API.LMSSetValue("cmi.suspend_data", "");
    API.LMSSetValue("cmi.core.lesson_location", "");
    API.LMSCommit("");
  } else if (trackingMethod.indexOf("2004") !== -1 && API_1484_11) {
    console.log("Found", trackingMethod, "API");
  }
};
